import React from "react"

const Content = (props) => {
  return <div {...props} className="container mx-auto border border-blue-900 bg-slate-400">{props.children}</div>
}

export default Content
